/**
 * Guards a PoR narrative section route using workspace page visibility.
 */
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import type { PorSectionType } from '../../types/plan-of-record';
import { PorVisiblePage } from './PorVisiblePage';

export function PorSectionRoute({
  porId,
  children,
}: {
  porId: string;
  children: ReactNode;
}) {
  const { sectionType } = useParams<{ sectionType: string }>();
  const pageKey = sectionType as PorSectionType;

  return (
    <PorVisiblePage porId={porId} pageKey={pageKey}>
      {children}
    </PorVisiblePage>
  );
}
